import { render, staticRenderFns } from "./CustomerEditForm.vue?vue&type=template&id=68abeb7e&scoped=true&"
import script from "./CustomerEditForm.vue?vue&type=script&lang=js&"
export * from "./CustomerEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditForm.vue?vue&type=style&index=0&id=68abeb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68abeb7e",
  null
  
)

export default component.exports